(() => {
  class ComfortDial extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.tabs = Array.from(this.querySelectorAll('[data-comfort-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-comfort-panel]'));
      this.visuals = Array.from(this.querySelectorAll('[data-comfort-visual]'));
      this.count = this.querySelector('[data-comfort-count]');
      this.caption = this.querySelector('[data-comfort-caption]');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.comfortTab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });

      this.dataset.ready = 'true';
    }

    activate(key, shouldFocus = false) {
      const activeTab = this.tabs.find((tab) => tab.dataset.comfortTab === key);
      if (!activeTab) return;

      this.dataset.active = key;

      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.comfortPanel !== key;
      });

      this.visuals.forEach((visual) => {
        const isActive = visual.dataset.comfortVisual === key;
        visual.classList.toggle('is-active', isActive);
        visual.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (this.count) this.count.textContent = activeTab.dataset.count || '';
      if (this.caption) this.caption.textContent = activeTab.dataset.caption || '';
      if (shouldFocus) activeTab.focus();
    }

    handleKeydown(event, currentIndex) {
      const lastIndex = this.tabs.length - 1;
      let nextIndex;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = lastIndex;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activate(this.tabs[nextIndex].dataset.comfortTab, true);
    }
  }

  if (!customElements.get('comfort-dial')) {
    customElements.define('comfort-dial', ComfortDial);
  }

  const bindHeroMotion = (hero) => {
    if (hero.dataset.motionReady === 'true') return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    hero.addEventListener('pointermove', (event) => {
      const bounds = hero.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 2;
      const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 2;
      hero.style.setProperty('--wr-pointer-x', x.toFixed(3));
      hero.style.setProperty('--wr-pointer-y', y.toFixed(3));
    });

    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--wr-pointer-x', '0');
      hero.style.setProperty('--wr-pointer-y', '0');
    });

    hero.dataset.motionReady = 'true';
  };

  const bindHeroMotionIn = (root = document) => {
    root.querySelectorAll('[data-wr-hero]').forEach(bindHeroMotion);
  };

  bindHeroMotionIn();
  document.addEventListener('shopify:section:load', (event) => bindHeroMotionIn(event.target));
})();
